export enum HazardousType {
EXPLOSIVES ="EXPLOSIVES",
FLAMMABLE_LIQUIDS ="FLAMMABLE_LIQUIDS",
OXIDISING_LIQUIDS ="OXIDISING_LIQUIDS",
COMPRESSED_GASES="COMPRESSED_GASES",
CORROSIVE="CORROSIVE",
ACUTE_TOXICITY="ACUTE_TOXICITY",
TOXIC_IRRATION="TOXIC_IRRATION",
ASPIRATION_HAZARD="ASPIRATION_HAZARD",
HAZARDOUS_TO_THE_AQUATIC_ENVIRONMENT="HAZARDOUS_TO_THE_AQUATIC_ENVIRONMENT"
}
